import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PortalLayout from "@/layouts/PortalLayout";
import { api } from "@/lib/api";
import { MapPin, Search } from "lucide-react";
import CompanyLogo from "@/components/CompanyLogo";
import { useLang } from "@/context/LangContext";

export default function MemberDirectory() {
  const { t } = useLang();
  const [companies, setCompanies] = useState([]);
  const [q, setQ] = useState("");
  const [sort, setSort] = useState("name-asc");

  useEffect(() => {
    const [s, o] = sort.split("-");
    const params = { sort: s, order: o };
    if (q) params.q = q;
    api.get("/companies", { params }).then((r) => setCompanies(r.data)).catch(() => {});
  }, [q, sort]);

  return (
    <PortalLayout sidebar="member">
      <h1 className="text-3xl font-bold text-navy md:text-4xl">Annuaire membres</h1>
      <p className="mt-1 text-neutral-600">{t("portal_memberdirectory_01")}</p>

      <div className="mt-6 flex flex-wrap items-center gap-3">
        <div className="relative max-w-md flex-1 min-w-[220px]">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-neutral-400" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Rechercher..." className="w-full rounded-full border border-neutral-200 bg-white py-2.5 pl-10 pr-3 text-sm" data-testid="directory-search" />
        </div>
        <select value={sort} onChange={(e) => setSort(e.target.value)} className="rounded-full border border-neutral-200 bg-white px-4 py-2.5 text-sm" data-testid="directory-sort">
          <option value="name-asc">Nom A → Z</option>
          <option value="name-desc">Nom Z → A</option>
          <option value="created_at-desc">{t("portal_memberdirectory_02")}</option>
          <option value="created_at-asc">Plus anciens d&apos;abord</option>
        </select>
      </div>

      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {companies.map((c) => (
          <Link key={c.id} to={`/members/${c.slug}`} className="rounded-2xl border border-neutral-100 bg-white p-5 transition-all hover:-translate-y-1 hover:shadow-md" data-testid={`directory-card-${c.id}`}>
            <div className="flex items-center gap-3">
              <CompanyLogo src={c.logo} name={c.name} size={48} className="rounded-xl" />
              <div className="flex-1 min-w-0">
                <div className="font-serif text-base font-semibold text-neutral-900 truncate">{c.name}</div>
                <div className="text-xs text-neutral-500 truncate"><MapPin className="inline h-3 w-3" /> {c.city}, {c.country}</div>
              </div>
            </div>
            <p className="mt-3 line-clamp-3 text-sm text-neutral-600">{c.description}</p>
            <span className="mt-3 inline-block rounded-full bg-wine-50 px-2.5 py-1 text-xs font-semibold text-wine-700">{c.category}</span>
          </Link>
        ))}
      </div>
    </PortalLayout>
  );
}
